export default __webpack_public_path__ + "static/media/logo.244e3062.png";